import { useContext, useMemo } from 'react';

import { graphql, useStaticQuery } from 'gatsby';
import { InternalLinkContext } from '.';

export type PagesSlugsResponse = {
  allSanityPage?: {
    nodes?: {
      id?: string;
      slug?: {
        current?: string;
      };
    }[];
  };
};

const PagesSlugsQuery = graphql`
  query PagesSlugsQuery {
    allSanityPage {
      nodes {
        id
        slug {
          current
        }
      }
    }
  }
`;

const useInternalLink = (id?: string) => {
  const pagesLinks = useStaticQuery<PagesSlugsResponse>(PagesSlugsQuery);
  const links = useContext(InternalLinkContext);

  const href = useMemo(() => {
    const page = pagesLinks?.allSanityPage?.nodes?.find((node) => node.id === id);
    const link = links?.find((link) => link?.id === id);
    return page?.slug?.current || link?.href;
  }, [pagesLinks, links, id]);

  return href;
};

export default useInternalLink;
